export const GDRIVE_BASE_API_ROUTER = 'https://www.googleapis.com/drive/v3/files';
